/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner } from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner';
import {
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerFromJSON,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerFromJSONTyped,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerToJSON,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerToJSONTyped,
} from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import type { CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument } from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument';
import {
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSON,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSONTyped,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSON,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSONTyped,
} from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument';

/**
 * 
 * @export
 * @interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInner
 */
export interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInner {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    s3_key?: string;
    /**
     * 
     */
    connector_document_id?: string;
    /**
     * Deprecated: use errors array with PROCESSING_ERROR type instead.
     * @deprecated
     */
    processing_error?: string;
    /**
     * 
     */
    created_by_user?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser;
    /**
     * 
     */
    external_ehr_document?: CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument;
    /**
     * 
     */
    errors?: Array<MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner>;
}

/**
 * Check if a given object implements the MatrixCarePatientDetailsDocumentsScreenerDocumentsInner interface.
 */
export function instanceOfMatrixCarePatientDetailsDocumentsScreenerDocumentsInner(value: object): value is MatrixCarePatientDetailsDocumentsScreenerDocumentsInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerFromJSON(json: any): MatrixCarePatientDetailsDocumentsScreenerDocumentsInner {
    return MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetailsDocumentsScreenerDocumentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        's3_key': json['s3_key'] == null ? undefined : json['s3_key'],
        'connector_document_id': json['connector_document_id'] == null ? undefined : json['connector_document_id'],
        'processing_error': json['processing_error'] == null ? undefined : json['processing_error'],
        'created_by_user': json['created_by_user'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON(json['created_by_user']),
        'external_ehr_document': json['external_ehr_document'] == null ? undefined : CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSON(json['external_ehr_document']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerFromJSON)),
    };
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerToJSON(json: any): MatrixCarePatientDetailsDocumentsScreenerDocumentsInner {
    return MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerToJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerToJSONTyped(value?: MatrixCarePatientDetailsDocumentsScreenerDocumentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        's3_key': value['s3_key'],
        'connector_document_id': value['connector_document_id'],
        'processing_error': value['processing_error'],
        'created_by_user': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON(value['created_by_user']),
        'external_ehr_document': CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSON(value['external_ehr_document']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerToJSON)),
    };
}

